export function deleteAudio(audioKey, setRecordings) {
  setRecordings(null);
}
